export const REFERRAL_CAMPAIGN_CODE = 'bowtie-friends-and-family-referral-program';
export const REFERRAL_REFEREE_CAMPAIGN_CODE = 'referral-campaign-referee';
export const CARRIED_OFFER_STORAGE_KEY = 'bowtieCarriedOffer';
export const CARRIED_OFFER_TTL_MS = 24 * 60 * 60 * 1000;